import { Component } from '@angular/core';

@Component({
    selector: 'app-home-dev',
    templateUrl: './home-dev.component.html',
    standalone: false
})
// componente creado para testear el funcionamiento del micro frontend
export class HomeDevComponent {

}
